export enum WindBraceDistributionStyle {
  Even = 'even',
  FixedAtEnds = 'fixed-at-ends',
}
